<template>
  <div>
    <add-question-to-quizz-form
      :isPromptActive="addQuestionFormPrompt"
      :callBackAddQuestionToQuizz="callBackAddQuestionToQuizz"
      @closePrompt="toggleAddQuestionFormPrompt"
    />
    <update-question-quizz-form
      :isPromptActive="updateQuestionFormPrompt"
      :callBackUpdateQuestion="callBackUpdateQuestion"
      :question="questionSelected"
      :questionIndex="questionSelectedIndex"
      @closePrompt="toggleUpdateQuestionFormPrompt"
    />
    <import-question-modal
      :isPromptActive="importQuestionPromptModal"
      :importQuestionCallBack="importQuestionCallBack"
      @closePrompt="toggleImportQuestionPromptModal"
    />
    <add-stream-to-evaluation
      :isPromptActive="addStreamFormPrompt"
      :callBackAddStream="callBackAddStream"
      :streams="streams"
      @closePrompt="toggleAddStreamFormPrompt"
    />
    <edit-stream-to-evaluation
      :isPromptActive="updateStreamFormPrompt"
      :callBackUpdateStream="callBackUpdateStream"
      :streams="streams"
      :entity="streamSelected"
      @closePrompt="toggleUpdateStreamFormPrompt"
    />

    <div class="flex-container">
      <div class="tab_menu">
        <div class="menu_items">
          <div
            class="menu_item"
            :class="
              form_step.slug == form_steps.step_information.slug
                ? 'is_active'
                : ''
            "
            @click="setupFormLevel(form_steps.step_information)"
          >
            <svg
              v-if="form_step.slug == form_steps.step_information.slug"
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 14.8481H4V12.8481H11V14.8481ZM14 10.8481H4V8.84814H14V10.8481ZM14 6.84814H4V4.84814H14V6.84814ZM16 0.848145H2C0.89 0.848145 0 1.73814 0 2.84814V16.8481C0 17.3786 0.210714 17.8873 0.585786 18.2624C0.960859 18.6374 1.46957 18.8481 2 18.8481H16C16.5304 18.8481 17.0391 18.6374 17.4142 18.2624C17.7893 17.8873 18 17.3786 18 16.8481V2.84814C18 2.31771 17.7893 1.809 17.4142 1.43393C17.0391 1.05886 16.5304 0.848145 16 0.848145Z"
                fill="#FFCC00"
              />
            </svg>
            <svg
              v-else
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 14H4V12H11V14ZM14 10H4V8H14V10ZM14 6H4V4H14V6ZM16 0H2C0.89 0 0 0.89 0 2V16C0 16.5304 0.210714 17.0391 0.585786 17.4142C0.960859 17.7893 1.46957 18 2 18H16C16.5304 18 17.0391 17.7893 17.4142 17.4142C17.7893 17.0391 18 16.5304 18 16V2C18 1.46957 17.7893 0.960859 17.4142 0.585786C17.0391 0.210714 16.5304 0 16 0Z"
                fill="black"
              />
            </svg>

            Informations
          </div>
          <div
            class="menu_item"
            :class="
              form_step.slug == form_steps.step_questions.slug
                ? 'is_active'
                : ''
            "
            @click="setupFormLevel(form_steps.step_questions)"
          >
            <svg
              v-if="form_step.slug == form_steps.step_questions.slug"
              width="21"
              height="22"
              viewBox="0 0 21 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.5 10.8481H17V6.84814C17 6.31771 16.7893 5.809 16.4142 5.43393C16.0391 5.05886 15.5304 4.84814 15 4.84814H11V3.34814C11 2.6851 10.7366 2.04922 10.2678 1.58038C9.79893 1.11154 9.16304 0.848145 8.5 0.848145C7.83696 0.848145 7.20107 1.11154 6.73223 1.58038C6.26339 2.04922 6 2.6851 6 3.34814V4.84814H2C1.46957 4.84814 0.960859 5.05886 0.585786 5.43393C0.210714 5.809 0 6.31771 0 6.84814V10.6481H1.5C3 10.6481 4.2 11.8481 4.2 13.3481C4.2 14.8481 3 16.0481 1.5 16.0481H0V19.8481C0 20.3786 0.210714 20.8873 0.585786 21.2624C0.960859 21.6374 1.46957 21.8481 2 21.8481H5.8V20.3481C5.8 18.8481 7 17.6481 8.5 17.6481C10 17.6481 11.2 18.8481 11.2 20.3481V21.8481H15C15.5304 21.8481 16.0391 21.6374 16.4142 21.2624C16.7893 20.8873 17 20.3786 17 19.8481V15.8481H18.5C19.163 15.8481 19.7989 15.5848 20.2678 15.1159C20.7366 14.6471 21 14.0112 21 13.3481C21 12.6851 20.7366 12.0492 20.2678 11.5804C19.7989 11.1115 19.163 10.8481 18.5 10.8481Z"
                fill="#FFCC00"
              />
            </svg>
            <svg
              v-else
              width="21"
              height="22"
              viewBox="0 0 21 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.5 10.8481H17V6.84814C17 6.31771 16.7893 5.809 16.4142 5.43393C16.0391 5.05886 15.5304 4.84814 15 4.84814H11V3.34814C11 2.6851 10.7366 2.04922 10.2678 1.58038C9.79893 1.11154 9.16304 0.848145 8.5 0.848145C7.83696 0.848145 7.20107 1.11154 6.73223 1.58038C6.26339 2.04922 6 2.6851 6 3.34814V4.84814H2C1.46957 4.84814 0.960859 5.05886 0.585786 5.43393C0.210714 5.809 0 6.31771 0 6.84814V10.6481H1.5C3 10.6481 4.2 11.8481 4.2 13.3481C4.2 14.8481 3 16.0481 1.5 16.0481H0V19.8481C0 20.3786 0.210714 20.8873 0.585786 21.2624C0.960859 21.6374 1.46957 21.8481 2 21.8481H5.8V20.3481C5.8 18.8481 7 17.6481 8.5 17.6481C10 17.6481 11.2 18.8481 11.2 20.3481V21.8481H15C15.5304 21.8481 16.0391 21.6374 16.4142 21.2624C16.7893 20.8873 17 20.3786 17 19.8481V15.8481H18.5C19.163 15.8481 19.7989 15.5848 20.2678 15.1159C20.7366 14.6471 21 14.0112 21 13.3481C21 12.6851 20.7366 12.0492 20.2678 11.5804C19.7989 11.1115 19.163 10.8481 18.5 10.8481Z"
                fill="black"
              />
            </svg>

            Streams
          </div>
        </div>
      </div>
      <div class="tab_content">
        <vs-card fixedHeight>
          <div slot="header">
            <span class="font-bold section-title">{{ form_step.title }}</span>
          </div>
          <!-- content -->
          <div
            class="form-container"
            v-if="form_step.slug == form_steps.step_information.slug"
          >
            <div class="form-left-container">
              <div>
                <p class="label">Titre de l’évaluation</p>
                <vs-input
                  class="w-full"
                  v-model="form.name"
                  :danger="error.name ? true : false"
                  :danger-text="error.name ? error.name[0] : ''"
                />
              </div>
              <div class="mt-4">
                <p class="label">Type de contrôle</p>
                <v-select
                  class="w-full"
                  label="name"
                  placeholder="Selectionner"
                  :reduce="(control) => control.id"
                  :options="controls"
                  v-model="form.blank"
                ></v-select>
              </div>
              <div class="mt-4">
                <p class="label">Catégorie</p>
                <v-select
                  class="w-full"
                  label="name"
                  placeholder="Selectionner"
                  :reduce="(category) => category.id"
                  :options="categories"
                  v-model="form.category_evaluation_id"
                ></v-select>
              </div>
              <div class="mt-4">
                <p class="label">
                  Formation <span class="optional-field">(optionnel)</span>
                </p>
                <v-select
                  class="w-full"
                  label="title"
                  placeholder="Selectionner"
                  :reduce="(training) => training.id"
                  :options="trainings"
                  v-model="form.training_id"
                  @search="searchTraining"
                >
                  <template slot="spinner" v-if="loading_training == true">
                    <div>
                      <svg class="spinner" viewBox="0 0 50 50">
                        <circle
                          class="path"
                          cx="25"
                          cy="25"
                          r="20"
                          fill="none"
                          stroke-width="5"
                        ></circle>
                      </svg>
                    </div>
                  </template>
                </v-select>
                <small class="optional-field"
                  >Veuillez joindre les formations pour cette évaluation</small
                >
              </div>
              <div class="mt-4">
                <p class="label">
                  Difficulté <span class="optional-field">(optionnel)</span>
                </p>
                <v-select
                  class="w-full"
                  label="name"
                  placeholder="Selectionner"
                  :reduce="(difficulty) => difficulty.id"
                  :options="difficulties"
                  v-model="form.difficulty"
                ></v-select>
              </div>
              <div class="mt-4">
                <p class="label">Durée de composition (minute)</p>
                <vs-input-number
                  min="1"
                  class="w-full"
                  color="#FFCC00"
                  v-model="form.duration"
                />
              </div>
              <div class="mt-4">
                <p class="label">Moyenne à obtenir (pourcentage)</p>
                <vs-input-number
                  min="1"
                  max="100"
                  class="w-full"
                  color="#FFCC00"
                  v-model="form.required_avg"
                />
              </div>
              <div class="mt-4">
                <p class="label">Nombre de recomposition possible</p>
                <vs-input-number
                  min="0"
                  class="w-full"
                  color="#FFCC00"
                  v-model="form.nbr_retry"
                />
              </div>
              <!-- <div class="mt-4">
                <p class="label">Nombre de question par questionnaire</p>
                <vs-input-number
                  min="1"
                  class="w-full"
                  color="#FFCC00"
                  v-model="form.nbr_question"
                />
              </div> -->
            </div>
            <div class="ml-2 form-right-container">
              <div>
                <p class="mb-1 label">Equipes</p>
                <treeselect
                  :clearable="tree_select_settings.clearable"
                  :searchable="tree_select_settings.searchable"
                  :open-on-click="tree_select_settings.openOnClick"
                  :auto-load-root-options="
                    tree_select_settings.autoLoadRrootOptions
                  "
                  :multiple="tree_select_settings.multiple"
                  :disable-branch-nodes="
                    tree_select_settings.disableBranchNodes
                  "
                  :show-count="tree_select_settings.showCount"
                  :value-consists-of="tree_select_settings.valueConsistsOf"
                  :options="options"
                  :load-options="loadTypeAgencies"
                  placeholder="Choisissez les équipes"
                  v-model="teams"
                />
              </div>
              <div class="mt-4 date-section w-full">
                <div class="w-full">
                  <p class="label">Date début</p>
                  <datetime
                    format="YYYY-MM-DD H:i"
                    v-model="form.date_start"
                  ></datetime>
                  <span style="color: red" v-if="error.date_start">{{
                    error.date_start ? error.date_start[0] : ""
                  }}</span>
                </div>
                <div class="w-full ml-2">
                  <p class="label">Date fin</p>
                  <datetime
                    format="YYYY-MM-DD H:i"
                    v-model="form.date_end"
                  ></datetime>
                  <span style="color: red" v-if="error.date_end">{{
                    error.date_end ? error.date_end[0] : ""
                  }}</span>
                </div>
              </div>
              <div class="period-section mt-4">
                <div class="w-1/2 pr-1">
                  <p class="label">Période</p>
                  <v-select
                    label="name"
                    placeholder="Selectionner"
                    :reduce="(period) => period.id"
                    :options="periods"
                    v-model="form.period"
                  ></v-select>
                </div>

                <div class="w-1/2 pl-1">
                  <p class="label">Mois</p>
                  <v-select
                    label="label"
                    placeholder="Selectionner"
                    :reduce="(month) => month.month"
                    :options="months"
                    v-model="form.month"
                  ></v-select>
                </div>
              </div>
              <div class="mt-4">
                <p class="label">Illustration</p>
                <vx-input-group class="mb-2">
                  <vs-input
                    v-model="illustation_name"
                    type="text"
                    :disabled="true"
                  />
                  <input
                    ref="illustration_evaluation"
                    name="illustration"
                    class="d-none"
                    type="file"
                    accept="image/*"
                    @change="onFileIllustrationChanged"
                  />

                  <template slot="append">
                    <div class="append-text btn-addon">
                      <vs-button
                        @click="$refs['illustration_evaluation'].click()"
                        color="#FFCC00"
                        class="text-dark font-bold"
                        >Parcourir</vs-button
                      >
                    </div>
                  </template>
                </vx-input-group>
                <p class="label mt-4">Aperçu ci-dessous</p>
                <div class="apercu_illustration" :style="cssProps">
                  <span v-if="!url"
                    >Veuillez selectionner une illustration</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div v-if="form_step.slug == form_steps.step_questions.slug">
            <div class="vx-row">
              <div class="w-full px-2">
                <vs-collapse type="margin">
                  <vs-collapse-item
                    v-for="(item, key) in form.streams"
                    :key="key"
                    :open="item.open ? true : false"
                  >
                    <div slot="header">
                      <span class="font-bold text-black"
                        >#{{ key + 1 + " - " + getStreamName(item) }}</span
                      >
                    </div>
                    <p class="mt-2">
                      Nombre de question pour le stream :
                      <span class="font-bold text-black">{{
                        item.nbr_question
                      }}</span>
                    </p>
                    <div class="vx-row w-full mt-4">
                      <div
                        class="ml-3 mr-4"
                        @click="
                          (streamSelected = item),
                            (streamSelectedIndex = key),
                            toggleUpdateStreamFormPrompt(true)
                        "
                      >
                        <feather-icon
                          icon="EditIcon"
                          style="color: #ffcc00"
                          svgClasses="w-4 h-4 stroke-current"
                          class="mr-1"
                        />
                        <span class="text-black eval_action">Modifier</span>
                      </div>
                      <div @click="deleteStream(key)">
                        <feather-icon
                          icon="TrashIcon"
                          style="color: #ffcc00"
                          svgClasses="w-4 h-4 stroke-current"
                          class="mr-1"
                        />
                        <span class="text-black eval_action">Supprimer</span>
                      </div>
                    </div>

                    <hr class="mt-6" />
                    <p class="section-title font-bold mt-4">
                      Liste des questions
                    </p>

                    <div class="vx-row">
                      <div class="data-list-container w-full">
                        <vs-table
                          ref="table"
                          max-items="10"
                          :data="item.questions"
                          search
                        >
                          <div
                            slot="header"
                            class="
                              flex flex-wrap-reverse
                              items-center
                              flex-grow
                              justify-between
                            "
                          >
                            <div
                              class="
                                flex flex-wrap-reverse
                                items-center
                                data-list-btn-container
                              "
                            >
                              <vs-button
                                @click="
                                  toggleAddQuestionFormPrompt(true),
                                    (streamSelectedIndex = key)
                                "
                                color="black"
                                class="text-white"
                                style="border-radius: 25px"
                                >Ajouter une question</vs-button
                              >
                              <vs-button
                                @click="
                                  toggleImportQuestionPromptModal(true),
                                    (streamSelectedIndex = key)
                                "
                                color="black"
                                class="text-white ml-2"
                                style="border-radius: 25px"
                                >Importer les questions</vs-button
                              >
                            </div>
                          </div>

                          <template slot="thead" color="#F3F2F7">
                            <vs-th sort-key="index">ID</vs-th>
                            <vs-th sort-key="question">Question</vs-th>
                            <vs-th sort-key="type_question_libelle"
                              >Type de questions</vs-th
                            >
                            <vs-th sort-key="instructions">Instructions</vs-th>
                            <vs-th>Actions</vs-th>
                          </template>

                          <template slot-scope="{ data }">
                            <tbody>
                              <vs-tr
                                :data="tr"
                                :key="indextr"
                                v-for="(tr, indextr) in data"
                              >
                                <vs-td>{{ tr.index }}</vs-td>
                                <vs-td>{{ tr.question }}</vs-td>
                                <vs-td>{{ tr.type_question_libelle }}</vs-td>
                                <vs-td>{{ tr.instructions }}</vs-td>
                                <vs-td>
                                  <div class="flex">
                                    <vx-tooltip text="Modifier la quetion">
                                      <feather-icon
                                        @click="
                                          showUpdateQuestionForm(
                                            tr,
                                            key,
                                            indextr
                                          )
                                        "
                                        icon="EditIcon"
                                        style="color: #ffcc00"
                                        svgClasses="w-5 h-5 stroke-current"
                                        class="mr-2"
                                      />
                                    </vx-tooltip>
                                    <vx-tooltip text="Supprimer la question">
                                      <feather-icon
                                        @click="deleteQuestion(key, indextr)"
                                        icon="TrashIcon"
                                        style="color: #ffcc00"
                                        svgClasses="w-5 h-5 stroke-current"
                                        class="mr-2"
                                      />
                                    </vx-tooltip>
                                  </div>
                                </vs-td>
                              </vs-tr>
                            </tbody>
                          </template>
                        </vs-table>
                      </div>
                    </div>
                  </vs-collapse-item>
                </vs-collapse>
              </div>
            </div>
            <vs-button
              @click="toggleAddStreamFormPrompt(true)"
              color="black"
              class="text-white form-button"
              >Ajouter un stream</vs-button
            >
          </div>
          <!-- end content -->
          <!-- footer -->
          <div class="footer mt-12">
            <vs-row vs-justify="flex-end" class="footer-row">
              <vs-button class="black-button" @click="disableForm"
                >Annuler</vs-button
              >
              <vs-button
                v-if="form_step.slug > 1"
                class="ml-2 black-button"
                @click="goToPreviousLevel"
                >Précédent</vs-button
              >
              <vs-button
                v-if="form_step.slug !== 2"
                class="ml-2 text-dark black-button"
                @click="goToNextLevel"
                >Suivant</vs-button
              >
              <vs-button
                @click="saveEvaluation()"
                v-if="isFormValid && form_step.slug == 2"
                class="ml-2 text-dark black-button"
                >Sauvegarder</vs-button
              >
              <vs-button
                @click="publishEvaluation()"
                v-if="
                  isFormValid && form_step.slug == 2 && form.published == false
                "
                class="ml-2 text-dark action-button"
                >Publier</vs-button
              >
            </vs-row>
          </div>
          <!-- end footer -->
        </vs-card>
      </div>
    </div>
  </div>
</template>
    
    <script>
import AddEvaluationInfo from "./components/addEvaluationInfo.vue";
import AddEvaluationQuestions from "./components/addEvaluationQuestions.vue";
import Treeselect from "@riophae/vue-treeselect";
import AddQuestionToQuizzForm from "../../Formation/Formation/components/quizz-components/add-questionToQuizzForm.vue";
import UpdateQuestionQuizzForm from "../../Formation/Formation/components/quizz-components/update-questionQuizzForm.vue";
import ImportQuestionModal from "../../Formation/Formation/components/quizz-components/importQuestionModal.vue";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { _buildQuery, _setupTreeView } from "../../../helpers/buildquery";
import datetime from "vuejs-datetimepicker";
import AddStreamToEvaluation from "./components/addStreamToEvaluation.vue";
import EditStreamToEvaluation from "./components/editStreamToEvaluation.vue";

export default {
  name: "editEvaluation",
  components: {
    AddEvaluationQuestions,
    AddEvaluationInfo,
    Treeselect,
    datetime,
    AddQuestionToQuizzForm,
    UpdateQuestionQuizzForm,
    ImportQuestionModal,
    AddStreamToEvaluation,
    EditStreamToEvaluation,
  },
  data() {
    return {
      form_steps: {
        step_information: {
          slug: 1,
          title: "Informations de l’évaluation",
        },
        step_questions: {
          slug: 2,
          title: "Ajout des streams",
        },
      },
      form_step: {
        slug: null,
        title: "",
      },
      error: {},
      form: {
        name: "",
        duration: 10,
        nbr_question: 50,
        nbr_retry: 1,
        required_avg: 50,
        category_evaluation_id: "",
        period: "",
        month: "",
        file: "",
        difficulty: "",
        published: false,
        blank: false,
        teams: "",
        training_id: "",
        date_start: "",
        date_end: "",
        streams: [],
      },
      types: {
        radio: "Choix unique",
        checkbox: "Choix multiple",
        text: "Texte",
      },
      teams: [],
      controls: [
        { id: false, name: "TTC Réel" },
        { id: true, name: "TTC Blanc" },
      ],
      difficulties: [
        { id: "easy", name: "Facile" },
        { id: "medium", name: "Moyen" },
        { id: "hard", name: "Difficile" },
      ],
      tree_select_settings: {
        clearable: true,
        searchable: true,
        openOnClick: true,
        autoLoadRrootOptions: false,
        multiple: true,
        disableBranchNodes: false,
        showCount: true,
        valueConsistsOf: "LEAF_PRIORITY",
      },
      url: "",
      options: null,
      categories: [],
      trainings: [],
      questions: [],
      months: [],
      periods: [],
      streams: [],
      isFormValid: false,
      cssProps: {},
      illustation_name: "",
      //prompts
      addQuestionFormPrompt: false,
      updateQuestionFormPrompt: false,
      importQuestionPromptModal: false,
      questionSelected: {},
      questionSelectedIndex: null,
      addQuestionFormPrompt: false,
      loading_training: false,
      questionSelectedStreamIndex: null,
      addStreamFormPrompt: false,
      updateStreamFormPrompt: false,
      streamSelected: {},
      streamSelectedIndex: null,
    };
  },
  computed: {},
  watch: {
    form: {
      handler: function () {
        this.checkForm();
      },
      deep: true,
    },
    teams: {
      handler: function () {
        this.checkForm();
      },
      deep: true,
    },
    questions: {
      handler: function () {
        this.checkForm();
      },
      deep: true,
    },
  },
  methods: {
    getStreamName(item) {
      let name = "";
      for (let index = 0; index < this.streams.length; index++) {
        const element = this.streams[index];
        if (element.id == item.stream_id) {
          name = element.name;
          break;
        }
      }
      return name;
    },
    callBackAddQuestionToQuizz(question) {
      question.index =
        "#" +
        (this.form.streams[this.streamSelectedIndex].questions.length + 1);
      question.type_question_libelle = this.types[question.type_question];
      this.form.streams[this.streamSelectedIndex].questions.push(question);
    },
    callBackUpdateStream(stream) {
      let can_update = true;
      for (let index = 0; index < this.form.streams.length; index++) {
        const element = this.form.streams[index];
        if (
          index !== this.streamSelectedIndex &&
          element.stream_id == stream.stream
        ) {
          can_update = false;
          window.getApp.error({
            response: { data: { message: "Vous avez déjà ajouté ce stream." } },
          });
          break;
        }
      }
      if (can_update) {
        this.form.streams[this.streamSelectedIndex].nbr_question =
          stream.nbr_question;
        this.form.streams[this.streamSelectedIndex].stream_id = stream.stream;
      }
    },
    callBackAddStream(stream) {
      let can_add = true;
      for (let index = 0; index < this.form.streams.length; index++) {
        const element = this.form.streams[index];
        if (element.stream_id == stream.stream) {
          can_add = false;
          window.getApp.error({
            response: { data: { message: "Vous avez déjà ajouté ce stream." } },
          });
          break;
        }
      }
      if (can_add) {
        this.form.streams.push({
          nbr_question: stream.nbr_question,
          open: true,
          questions: [],
          stream_id: stream.stream,
        });
      }
    },
    toggleAddQuestionFormPrompt(val = false) {
      this.addQuestionFormPrompt = val;
    },
    callBackUpdateQuestion(question, indexQuestion) {
      this.form.streams[this.streamSelectedIndex].questions[indexQuestion] =
        question;
    },
    toggleUpdateQuestionFormPrompt(val = false) {
      this.updateQuestionFormPrompt = val;
    },
    deleteQuestion(indexStream, indexQuestion) {
      this.form.streams[indexStream].questions.splice(indexQuestion, 1);
      this.form.streams[indexStream].questions.forEach((question, index) => {
        this.form.streams[indexStream].questions[index].index =
          "#" + (index + 1);
      });
    },
    importQuestionCallBack(questions) {
      questions.forEach((element) => {
        element.index =
          "#" +
          (this.form.streams[this.streamSelectedIndex].questions.length + 1);
        element.type_question_libelle = this.types[element.type_question];
        this.form.streams[this.streamSelectedIndex].questions.push(element);
      });
    },
    toggleAddStreamFormPrompt(val = false) {
      this.addStreamFormPrompt = val;
    },
    toggleUpdateStreamFormPrompt(val = false) {
      this.updateStreamFormPrompt = val;
    },
    toggleImportQuestionPromptModal(val = false) {
      this.importQuestionPromptModal = val;
    },
    showUpdateQuestionForm(model, indexStream, indexQuestion) {
      this.questionSelected = model;
      this.questionSelectedIndex = indexQuestion;
      this.streamSelectedIndex = indexStream;
      this.toggleUpdateQuestionFormPrompt(true);
    },
    deleteStream(index) {
      this.form.streams.splice(index, 1);
    },
    checkForm() {
      if (
        this.form.name !== "" &&
        this.form.duration !== "" &&
        // this.form.nbr_question !== "" &&
        this.form.nbr_retry !== "" &&
        this.form.required_avg !== "" &&
        this.form.category_evaluation_id !== "" &&
        this.form.period !== "" &&
        this.form.month !== "" &&
        this.url !== "" &&
        this.form.blank !== "" &&
        this.teams.length > 0 &&
        this.form.date_start !== "" &&
        this.form.date_end !== "" &&
        this.form.streams.length > 0 &&
        this.checkStreams()
      ) {
        // console.log(this.form);
        this.isFormValid = true;
      } else this.isFormValid = false;
    },
    checkStreams() {
      let cpt = 0;
      this.form.streams.forEach((element) => {
        if (
          element.id !== "" &&
          element.nbr_question !== "" &&
          element.questions.length > 0
        )
          cpt++;
      });
      return cpt == this.form.streams.length ? true : false;
    },
    setupFormLevel(step) {
      this.form_step = step;
    },
    disableForm() {
      this.setupFormLevel(this.form_steps.step_information);
      this.empty_form = true;
    },
    goToNextLevel() {
      const next_level = this.form_step.slug + 1;
      Object.entries(this.form_steps).forEach(([key, value]) => {
        if (value.slug == next_level) {
          this.form_step = value;
          return true;
        }
      });
    },
    goToPreviousLevel() {
      Object.entries(this.form_steps).forEach(([key, value]) => {
        if (value.slug == this.form_step.slug - 1) {
          this.form_step = value;
          return true;
        }
      });
    },
    callBackInformation(model) {
      this.form.information = model;
      this.checkForm();
    },
    publishTrainingPack() {
      this.published = true;
      this.saveTrainingPack();
    },
    async loadTypeAgencies() {
      this.$vs.loading();
      let response = await this.$http.get("/categories/agencies");
      if (response.data) {
        let type_agencies = response.data.data;

        this.options = _setupTreeView(type_agencies, false);
        this.$vs.loading.close();
      }
    },
    getCategories() {
      this.$http.get("/categories/evaluations").then((response) => {
        this.categories = response.data.data;
      });
    },
    getMonths() {
      this.$http.get("/evaluation/getMonths").then((response) => {
        this.months = response.data;
      });
    },
    getPeriods() {
      this.$http.get("/periods").then((response) => {
        this.periods = response.data;
      });
    },
    getStreams() {
      this.$http.get("/evaluation-streams").then((response) => {
        this.streams = response.data;
      });
    },
    async uploadImg() {
      let formData = new FormData();
      formData.append("file", this.form.file);
      let response = await this.$http.post("/medias/upload", formData);
      if (response) {
        // console.log(response);
      }
    },
    onFileIllustrationChanged(e) {
      this.cssProps = {};
      this.form.file = e.target.files[0];
      this.illustation_name = this.form.file.name;
      this.url = URL.createObjectURL(this.form.file);

      if (this.form.file) {
        this.cssProps.backgroundImage = `url(${this.url})`;
        this.cssProps.backgroundSize = `100% 100% !important`;
        this.cssProps.backgroundRepeat = `no-repeat !important`;
      }
    },
    async searchTraining(search_string) {
      this.trainings = [];
      this.loading_training = true;
      try {
        let response = await this.$http.get(
          "trainings" + _buildQuery({ search: search_string, limit: 200 })
        );
        if (response) {
          this.trainings = response.data.data;
          this.loading_training = false;
        }
      } catch (error) {
        // console.log(error);
        this.loading_training = false;
      }
    },
    async getTrainings() {
      try {
        this.loading_training = true;
        let response = await this.$http.get("/trainings?limit=200");
        if (response.data) {
          this.trainings = response.data.data;
          this.$vs.loading.close();
          this.loading_training = false;
        }
      } catch (error) {
        if (error.response.data.status === 401) {
          this.$vs.notify({
            title: "Erreur",
            text: "Votre session a expiré",
            color: "danger",
            position: "top-right",
          });
          this.$vs.loading.close();
          this.$router.push("/login");
        }
        this.loading_training = false;
      }
    },
    async saveEvaluation() {
      try {
        this.$vs.loading();
        let formData = new FormData();
        formData.append("name", this.form.name);
        formData.append("duration", this.form.duration);
        // formData.append("nbr_question", this.form.nbr_question);
        formData.append("nbr_retry", this.form.nbr_retry);
        formData.append("required_avg", this.form.required_avg);
        formData.append(
          "category_evaluation_id",
          this.form.category_evaluation_id
        );
        formData.append("period", this.form.period);
        formData.append("month", this.form.month);
        formData.append("file", this.form.file ? this.form.file : "");
        formData.append(
          "difficulty",
          this.form.difficulty ? this.form.difficulty : ""
        );
        formData.append("published", this.form.published);
        formData.append("blank", this.form.blank);
        formData.append("teams", this.teams.join(","));
        formData.append(
          "training_id",
          this.form.training_id ? this.form.training_id : ""
        );
        formData.append("date_start", this.form.date_start);
        formData.append("date_end", this.form.date_end);

        this.form.streams.forEach((stream, indexStream) => {
          formData.append("streams[" + indexStream + "][id]", stream.stream_id);
          formData.append(
            "streams[" + indexStream + "][nbr_question]",
            stream.nbr_question
          );

          stream.questions.forEach((question, index) => {
            if (question.slug) {
              formData.append(
                "streams[" +
                  indexStream +
                  "][questions][" +
                  index +
                  "][slug]",
                question.slug
              );
            }
            formData.append(
              "streams[" +
                indexStream +
                "][questions][" +
                index +
                "][question]",
              question.question
            );
            formData.append(
              "streams[" +
                indexStream +
                "][questions][" +
                index +
                "][type_question]",
              question.type_question
            );
            formData.append(
              "streams[" +
                indexStream +
                "][questions][" +
                index +
                "][instructions]",
              question.instructions
            );
            // console.log(question);
            if (Array.isArray(question.answers)) {
              question.answers.forEach((answer, answer_index) => {
                formData.append(
                  "streams[" +
                    indexStream +
                    "][questions][" +
                    index +
                    "][answers][" +
                    answer_index +
                    "][answers]",
                  answer.answers
                );
                formData.append(
                  "streams[" +
                    indexStream +
                    "][questions][" +
                    index +
                    "][answers][" +
                    answer_index +
                    "][correct]",
                  answer.correct
                );
              });
            } else
              formData.append(
                "streams[" +
                  indexStream +
                  "][questions][" +
                  index +
                  "][answers]",
                question.answers
              );
          });
        });
        // console.log(formData);
        // return;
        let response = await this.$http.post(
          "/evaluations/" + this.$route.params.id,
          formData
        );
        if (response) {
          this.error = [];
          window.getApp.success("L'évaluation a été modifiée avec succès.", {});
          this.$vs.loading.close();
          this.$router.push({ path: "/evaluation/all" });
        }
      } catch (error) {
        this.$vs.loading.close();
        this.error = error.response.data.errors;
      }
    },
    async publishEvaluation() {
      this.form.published = true;
      this.saveEvaluation();
    },
    async getEvaluation() {
      try {
        let response = await this.$http.get(
          "/evaluations/" + this.$route.params.id
        );
        if (response) {
          let content = response.data;
          this.form.name = content.name;
          this.form.duration = content.duration;
          // this.form.nbr_question = content.nbr_question;
          this.form.nbr_retry = content.nbr_retry;
          this.form.required_avg = content.required_avg;
          this.form.category_evaluation_id = content.category_evaluation_id;
          this.form.period = content.period_id;
          this.form.month = content.month;
          this.form.difficulty = content.difficulty;
          this.form.published = content.published;
          this.form.blank = content.blank;
          this.teams = content.teams;
          this.form.training_id = content.training_id;
          this.form.date_start = content.date_start;
          this.form.date_end = content.date_end;
          if (content.media) {
            this.url = content.media.full_path;
            // this.form.file = true;
            this.illustation_name = content.media.name;
            this.cssProps.backgroundImage = `url(${this.url})`;
            this.cssProps.backgroundSize = `100% 100% !important`;
            this.cssProps.backgroundRepeat = `no-repeat !important`;
          }

          content.streams.forEach((stream) => {
            let questions = [];
            let streamData = {
              stream_id: stream.id,
              name: stream.name,
              nbr_question: stream.nbr_question,
              questions: [],
            };
            stream.questions.forEach((question) => {
              questions.push({
                index: "#" + (questions.length + 1),
                slug: question.slug,
                question: question.question,
                instructions: question.instructions,
                type_question: question.type,
                type_question_libelle: this.types[question.type],
                // answers: this.formatAnswers(question.answers),
                answers: question.answers,
              });
            });
            streamData.questions = questions;
            this.form.streams.push(streamData);
          });
          this.checkForm();

          this.$vs.loading.close();
        }
      } catch (error) {
        this.$vs.loading.close();
        // console.log(error);
        if (error.response.status == 422) {
          this.error = error.response.data.errors;
        }
        // console.log(error);
      }
    },
    formatAnswers(answers) {
      let responses = [];
      if (Array.isArray(answers)) {
        answers.forEach((answer) => {
          responses.push({
            answers: answer.answers,
            correct: answer.correct === "true",
          });
        });
      }else responses = answers;
      return responses;
    },
  },
  mounted() {
    this.loadTypeAgencies();
    this.getTrainings();
    this.getPeriods();
    this.getMonths();
    this.getCategories();
    this.getEvaluation();
    this.getStreams();
    this.form_step = this.form_steps.step_information;
    // this.form_step = this.form_steps.step_questions;
  },
};
</script>
    
  <style lang="scss" scoped>
.section-title {
  font-size: 24px;
}

.flex-container {
  display: flex;
  flex-wrap: nowrap;

  .tab_menu {
    width: auto;
    margin-right: 8px;
  }

  .tab_content {
    width: 100%;
    // margin: 3px;
  }
}

.menu_items {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  gap: 6px 0px;
  grid-template-areas:
    "."
    "."
    ".";
  .menu_item {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 23px;
    gap: 10px;
    width: 188px;
    height: 44px;
    border-radius: 5px;
    color: #000000;
    font-weight: bold;
    cursor: pointer;
  }

  .is_active {
    background: #000000;
    color: #ffcc00;
    border-radius: 5px;
  }
}

.form-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  gap: 0px 4px;
  grid-template-areas: ". right";
}
.form-left-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto !important;
  gap: 0px 0px;
}

.form-right-container {
  grid-area: right;
  .date-section {
    display: inline-flex;
  }
  .period-section {
    display: flex;
    flex-wrap: wrap;
  }
}

.vs-input-number {
  margin: 0px !important;
  button {
    color: #000000;
  }
}

.d-none {
  display: none;
}

.label {
  color: #000000;
  font-weight: 400;
  font-size: 13px;
  line-height: 21px;
  .optional-field {
    color: #6e6b7b;
  }
}

.footer-row {
  position: absolute;
  bottom: 2%;
  left: -2%;
  justify-content: end;
}
.footer {
  button {
    /* Auto layout */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 25px;
    background: transparent !important;
  }

  .black-button {
    border: 1px solid black;
    background: transparent !important;
    color: black;
  }
  .action-button {
    background: #ffcc00 !important;
  }
}

.footer button:hover {
  box-shadow: 0px 0px 0px transparent !important;
}

.vs-collapse-item {
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1) !important;
}
.con-vs-card.fixedHeight {
  min-height: 585px !important;
  position: relative;
}
.vs-card--content.fixedHeight {
  min-height: 585px !important;
}

.spinner {
  animation: rotate 2s linear infinite;
  z-index: 2;
  position: absolute;
  // top: 50%;
  left: 99.5%;
  margin: -25px 0 0 -25px;
  width: 27px;
  height: 50px;

  & .path {
    stroke: hsl(210, 70, 75);
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
</style>
    